module.exports = __webpack_public_path__ + "img/howto3.7676a180.png";